<!-- Notificación de alerta crítica (pánico, GPS off, etc.) -->
<section class="error-border-alarm" *ngIf="!isGpsTrackingAlert()">
    <header class="error-header">
        <div class="title light">
            <i class="fas fa-exclamation-triangle"></i> {{notification.title}}
        </div>
    </header>
    <br>
    <main class="prebody">
        <div class="body-wrapper">
            <div class="body">
                <p class="description" [innerHTML]="getDescription()"></p>
                <div>
                    <div class="title subtitle text-center text-panic">Ubicación</div>
                    <div class="row">
                        <div class="col-md-6" *ngIf="cargo?.lastPointLocationGps?.location.lat && cargo?.lastPointLocationGps?.location.lng">
                            <app-standard-map [options]="mapOptions"></app-standard-map>
                        </div>
                        <div [ngClass]="{'col-md-6': cargo?.lastPointLocationGps?.location.lat && cargo?.lastPointLocationGps?.location.lng, 'col-12': !(cargo?.lastPointLocationGps?.location.lat && cargo?.lastPointLocationGps?.location.lng)}">
                            <div class="address-container">
                                <div class="address-progress initial-address">
                                    <i class="fas fa-circle"></i>
                                </div>
                                <div class="address">
                                    <div class="text-panic">Dirección origen</div>
                                    <p>{{cargo?.cargoFeature?.uploadDownload?.origin?.addresses[0]?.address}}</p>
                                </div>
                            </div>

                            <div class="address-container">
                                <div class="address-progress final-address">
                                    <i class="fas fa-circle"></i>
                                </div>
                                <div class="address">
                                    <div class="text-panic">Dirección destino</div>
                                    <p>{{
                                        cargo
                                        ?.cargoFeature
                                        ?.uploadDownload
                                        ?.destination[
                                        cargo
                                        ?.cargoFeature
                                        ?.uploadDownload
                                        ?.destination.length - 1
                                        ]
                                        ?.addresses[
                                        cargo
                                        ?.cargoFeature
                                        ?.uploadDownload
                                        ?.destination[
                                        cargo
                                        ?.cargoFeature
                                        ?.uploadDownload
                                        ?.destination.length - 1
                                        ]
                                        ?.addresses.length - 1
                                        ]
                                        ?.address
                                        }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="w-100 text-right">
                <button class="goToCargoButton text-panic" (click)="goToCargoDetail()">Ir al detalle del servicio <i
                        class="fas action-secondary fa-arrow-right"></i></button>
            </div>
        </div>
    </main>
</section>

<!-- Notificación de sin reporte GPS (15 minutos) -->
<section class="warning-border-notification" *ngIf="isGpsTrackingAlert()">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions t-0" (click)="matDialogRef.close()"></i>
    <main class="warning-prebody">
        <div class="warning-body-wrapper">
            <h2 class="gps-alert-title">{{notification.title}}</h2>
            <p class="gps-alert-date" *ngIf="getFormattedDate()">
                <span class="gps-alert-date-label">Fecha de la notificación:</span>
                <i class="fas fa-clock mr-2"></i>
                {{getFormattedDate() | dateFormat:'date-time-full'}}
            </p>
            <p class="gps-alert-description">Los siguientes son los vehículos que actualmente están presentando fallas de conexión de su GPS.</p>
            
            <div class="table-container-scroll">
                <table class="table table-striped mb-0">
                    <thead>
                        <tr>
                            <th>Placa</th>
                            <th>ID</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cargo of getAffectedCargos()">
                            <td data-cell="Placa">{{cargo.licensePlate}}</td>
                            <td data-cell="ID">{{cargo.consecutive}}</td>
                            <td data-cell="Acción">
                                <a href="#" class="color-primary" (click)="goToCargoDetail(cargo.consecutive); $event.preventDefault()">
                                    Ir al servicio <i class="fas fa-arrow-right ml-1"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </main>
</section>